import { gameReducer } from '@/features/gameSession';
import { sharedReducer } from '@/shared/app';
import errorHandlerReducer from '@/shared/modules/errorHandler/reducer';
import imagePreviewReducer from '@/shared/modules/imagePreview/reducer';
import notificationReducer from '@/shared/modules/notification/reducer';
import { playButtonReducer } from '@/shared/modules/playButton';

export type ReducerState<T> = T extends (...args: any[]) => infer R ? R : never;

export const reducers = {
	errorHandlerReducer,
	gameReducer,
	imagePreviewReducer,
	notificationReducer,
	playButtonReducer,
	sharedReducer,
};

export type RootState = {
	[K in keyof typeof reducers]: ReducerState<(typeof reducers)[K]>;
};
